export enum PillColor {
  ORANGE_LIGHT = 'ORANGE_LIGHT',
  NEUTRAL_200 = 'NEUTRAL_200',
  HIGH_CONTRAST = 'HIGH_CONTRAST'
}

export enum PillType {
  NORMAL = 'NORMAL',
  WRAPPED_START = 'WRAPPED_START',
  WRAPPED_END = 'WRAPPED_END'
}
